import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface CreateProjectRolePopoverProps {
  onSubmit: () => void
  resetEmployeeSelection: () => void
  disabledSubmitButton: boolean
  excludeEmployeeIds: string[]
  employeeSelection: EmployeeSelectorV2MultiSelectState
  onSelectEmployees: (selection: EmployeeSelectorV2MultiSelectState) => void
}

const CreateProjectRolePopover = ({
  onSubmit,
  resetEmployeeSelection,
  disabledSubmitButton,
  excludeEmployeeIds,
  employeeSelection,
  onSelectEmployees,
}: CreateProjectRolePopoverProps) => {
  const [open, toggle] = useToggle(false)

  const selectedCount = employeeSelection.type === 'manual' ? employeeSelection.ids.length : 0

  const onClickPopover = () => {
    onSubmit()
    toggle(!open)()
  }

  const onSubmitPopover = () => {
    onSubmit()
    resetEmployeeSelection()
    toggle(false)()
  }

  const buttonTitle = () => {
    switch (selectedCount) {
      case 0:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.zero_selected'
        )
      case 1:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.one_selected'
        )
      default:
        return i18n.t(
          'project_management.modals.create_project.wizard.step_two.select_button.other_selected',
          { counter: selectedCount }
        )
    }
  }

  return (
    <Box paddingTop="s24" style={{ display: 'inline' }}>
      <PopoverMenu type="dialog" onClick={onClickPopover} open={open}>
        <PopoverMenu.Trigger>
          <Button iconName="add" type={'secondary'}>
            {i18n.t('common.add')}
          </Button>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="right" align="center" width="s360">
          <Box paddingX="s12">
            <EmployeeSelectorV2
              multiple
              options={{ asList: true, disableSelectAll: true }}
              forcedFilters={{ excludeCurrentEmployee: true, excludeIds: excludeEmployeeIds }}
              onChange={onSelectEmployees}
            />
            <Box paddingTop="s16">
              <Button type="primary" onClick={onSubmitPopover} disabled={disabledSubmitButton}>
                {buttonTitle()}
              </Button>
            </Box>
          </Box>
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export default CreateProjectRolePopover
